var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.302,
    height: 24.302,
    viewBox: "0 0 24.302 24.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picture_1_",
    "data-name": "picture (1)",
    transform: "translate(0.35 0.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26031",
    "data-name": "Path 26031",
    d: "M18.685,0H4.917A4.923,4.923,0,0,0,0,4.917V18.685A4.923,4.923,0,0,0,4.917,23.6H18.685A4.923,4.923,0,0,0,23.6,18.685V4.917A4.923,4.923,0,0,0,18.685,0ZM4.917,1.967H18.685a2.95,2.95,0,0,1,2.95,2.95V18.685a2.9,2.9,0,0,1-.3,1.264l-9.011-9.011a4.917,4.917,0,0,0-6.955,0L1.967,14.344V4.917a2.95,2.95,0,0,1,2.95-2.95Zm0,19.668a2.95,2.95,0,0,1-2.95-2.95v-1.56l4.8-4.8a2.95,2.95,0,0,1,4.174,0l9.011,9.012a2.9,2.9,0,0,1-1.264.3Z",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26032",
    "data-name": "Path 26032",
    d: "M15.942,10.384A3.442,3.442,0,1,0,12.5,6.942a3.442,3.442,0,0,0,3.442,3.442Zm0-4.917a1.475,1.475,0,1,1-1.475,1.475A1.475,1.475,0,0,1,15.942,5.467Z",
    transform: "translate(-0.208 -0.058)",
    stroke: "#fff",
    strokeWidth: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/imageUpload.fb3f077c9da38147871a736ff6075ed4.svg";
export { ForwardRef as ReactComponent };